
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_336_20973)"}},[_c('path',{attrs:{"d":"M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z","fill":"#3B5998"}}),_c('path',{attrs:{"d":"M15.017 12.47h-2.141v7.844H9.63V12.47H8.088V9.713h1.543V7.929c0-1.276.606-3.274 3.273-3.274l2.403.01v2.676h-1.743c-.286 0-.688.143-.688.752v1.622H15.3l-.283 2.755z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_336_20973"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    